const React = require('react');
const {default: IconButton} = require("@material-ui/core/IconButton");
const {default: VisibilityOff} = require("@material-ui/icons/VisibilityOff");
const {default: Visibility} = require("@material-ui/icons/Visibility");
const TextField = require("../../../../../../../dumb/TextField/H");
const WrapperWithLoading = require("../../../../../../../dumb/WrapperWithLoading");
const Popup = require("../../../../../../../dumb/Popup/C");
const {apiAdminCustomerRefundStart} = require("../../../../../../../../api/admin/refunds");
const openStatusCustomerRefundPopup = require("../../utils/openStatusCustomerRefundPopup");

module.exports = ({caption, state, setState, issue_id, update, close}) => {

  const {showPassword, password, clicked} = state;

  const invalidPassword = !password;
  const disabled = invalidPassword;

  const VisibilityIcon = showPassword
    ? VisibilityOff
    : Visibility;

  const pwdInputProps = {
    autoComplete: 'new-password',
    endAdornment: (
      <IconButton
        className="rlv sl8 mv-5*2"
        onClick={() => {
          setState({
            showPassword: !showPassword,
          });
        }}
      >
        <VisibilityIcon
          className="c0C"
        />
      </IconButton>
    ),
  }

  return (
    <Popup
      caption={caption}
      onCancel={close}
      disabled={state.loading || (clicked && disabled)}
      text="Start"
      onSave={() => {
        if (disabled) {
          setState({clicked: true});
          return;
        }

        setState({loading: true});

        apiAdminCustomerRefundStart({issue_id, password}).finally((error) => {
          setState({
            loading: false,
          });

          if (error) {
            return;
          }
          update && update()
          close();
          setTimeout(() => {
            openStatusCustomerRefundPopup({id: issue_id}, update)
          }, 500);
        });
      }}
    >
      <p className="wmax910 mv20">
        Please enter the admin password to begin refund process
      </p>
      <WrapperWithLoading
        loading={state.loading}
      >
        <TextField
          label="Password *"
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(e) => {
            setState({password: e.target.value});
          }}
          error={clicked && invalidPassword}
          InputProps={pwdInputProps}
        />
      </WrapperWithLoading>
    </Popup>
  )
}
